<template>
  <PageTemplate>
    <h1>Forum</h1>

    <fieldset class="fieldset">
      <v-input-wrap prefix="search">
        <v-input
          type="search"
          @search="performSearchAction"
          @input="performSearch"
          @keyup="performSearchAction"
        />
      </v-input-wrap>
    </fieldset>
    <div
      v-if="!isSearchMode"
      class="row"
    >
      <div class="col-lg-3">
        <template v-if="(committeePermissions !== null && committeePermissions.write) || this.checkIfCommitteeAdmin">
          <v-button
            size="lg"
            is-block
            link="#/forum/new-discussion"
          >
            + New Discussion
          </v-button>
        </template>
      </div>
      <div class="col-lg-12">
        <v-card title="Discussions">
          <v-discussion
            v-for="forum in forums"
            :key="forum.id"
            :title="forum.title"
            :author="getPostedBy(forum.user)"
            :categories="[]"
            :date="getLocalDate(forum.created_at)"
            :comments="1*forum.replies_count"
            :link="getDetailsLink(forum)"
          >
            <span v-html="forum.post" />
          </v-discussion>
          <p v-if="forums.length <= 0">
            No forum thread available!
          </p>
        </v-card>
      </div>
    </div>
    <div
      v-else
    >
      <div style="clear:both;">
        Showing Forum threads related to "{{ searchKeyword }}"
      </div>
      <div>
        <v-card title="Discussions">
          <v-discussion
            v-for="forum in searchResults"
            :key="forum.id"
            :title="forum.title"
            :author="getPostedBy(forum.user)"
            :categories="[]"
            :date="getLocalDate(forum.created_at)"
            :comments="1*forum.replies_count"
            :link="getDetailsLink(forum)"
          >
            <span v-html="forum.post" />
          </v-discussion>
          <p v-if="forums.length <= 0">
            No forum thread available!
          </p>
        </v-card>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from "@/templates/Page/index.vue";
import Discussion from "@/molecules/Discussion";
import Card from "@/molecules/Card";
import Button from "@/atoms/Button";
import InputWithIcon from "@/molecules/InputWithIcon";
import Input from "@/atoms/Input";
import { buildBreadCrumb } from "@/common/tableFunctions";
import {mapState} from "vuex";
import routes from "@/common/routes";
import { formatDate } from "@/common/formatting";
import {checkIfCommitteeAdmin} from "@/common/switchCommittee";
import {
  GET_FORUM_CATEGORIES,
  GET_FORUM_THREADS,
  LOAD_FORUM_THREADS,
  CLEAR_SELECTED_CATEGORIES_ACTION,
  FORUM_SEARCH
} from "@/store/actions.type";

export default {
  name: "Forum",
  components: {
    "v-discussion": Discussion,
    "v-button": Button,
    "v-card": Card,
    "v-input": Input,
    "v-input-wrap": InputWithIcon,
    PageTemplate
  },
  data: function() {
    return {
      categories: [],
      allForums: [],
      forums: [],
      selectedCategoryIds: [],
      isSearchMode: false,
      searchResults: [],
      searchKeyword: ''
    };
  },
  computed: {
    selectedCommittee() {
      return this.$store.getters.getSelectedCommittee;
    },
    categoryList() {
      return this.categories;
    },
    ...mapState({
      committeePermissions: state => state.auth.committeePermissions
    }),
    checkIfCommitteeAdmin,
  },
  watch: {
    selectedCommittee: {
      handler(val, oldVal) {
        this.switchCommitte(val);
      }
    },
  },
  mounted() {
    this.updateBreadCrumb();
    this.getForumThreads(true);
  },
  methods: {
    updateBreadCrumb: function(fn) {
      let breadcrumbs = [];
      breadcrumbs["Dashboard"] = routes.DASHBOARD;
      breadcrumbs["Forum"] = "";
      this.$store.dispatch(
        "updateBreadCrumbAction",
        buildBreadCrumb(breadcrumbs)
      );
    },
    switchCommitte: function(committeId) {
      //1. update forums with threads of this (current) Committe.
      this.getForumThreads(false);
    },
    getForumThreads(useCacheIfExists) {
      if (!this.$store.getters.getSelectedCommittee) {
        this.forums = [];
        return;
      }
      return this.$store
        .dispatch(GET_FORUM_THREADS, {
          committeeid: this.$store.getters.getSelectedCommittee,
          useCacheIfExists: useCacheIfExists
        })
        .then(response => {
          this.allForums = response;
          this.forums = response;
        })
        .catch(err => {
          console.error("Error: While loading forums. " + err);
        });
    },
    getPostedBy(user) {
      if(user)
      return (
        (user.first_name ? user.first_name : "") +
        " " +
        (user.middle_name ? user.middle_name : "") +
        " " +
        (user.last_name ? user.last_name : "")
      );
      return "default";
    },
    getDetailsLink(thread) {
      return "/discussion/" + thread.id;
    },
    getLocalDate(date) {
        return formatDate(date);
    },
    performSearch: function(evt) {
     this.searchKeyword = evt;
     if(evt.length === 0) {
       this.isSearchMode = false;
     }
    },
    performSearchAction: function(evt) {
     this.searchKeyword = evt.target? evt.target.value: evt;
        if(this.searchKeyword == this.processedKey) {
          return;
        }
     this.processedKey = ''+this.searchKeyword;
     this.isSearchMode = (this.searchKeyword.length === 0 ? false : true);
      return this.$store
        .dispatch(FORUM_SEARCH, {term: this.searchKeyword, cmid: this.selectedCommittee})
        .then(response => {
          this.searchResults = response;
        })
        .catch(err => {
          console.error("Error: While loading categories. " + err);
          this.searchResults = [];
        });
    },

  }
};
</script>

